{
  "version": 1,
  "asset_id": "afb29d18-c6ff-4403-a265-d7adcd7cee71",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/afb29d18-c6ff-4403-a265-d7adcd7cee71/hiatal-type-2-es-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/afb29d18-c6ff-4403-a265-d7adcd7cee71/hiatal-type-2-es-v3-1200.webp",
  "original_filename": "hiatal-type-2-es-v3-1200.webp",
  "size": 143822,
  "content_type": "image/webp",
  "created_at": "2026-10-28T19:42:28Z"
}
